export default "__VITE_ASSET__DUoxF8gh__"